'use client';

import { RefObject, useState } from 'react';
import { Content } from '@prismicio/client';
import { PrismicNextLink } from '@prismicio/next';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { Simplify } from '../../../../prismicio-types';
import { ScreenSize, useOutsideClick } from '@/hooks';
import { screenSizes } from '@/constants';
import {
  IconMinus,
  IconPlus,
  LinkIcon,
} from '@/assets/icons/PartnerPagesIcons';
import styles from './Card.module.scss';

interface Props {
  data: Simplify<Content.PartnerBenefitsSliceDefaultPrimaryCardsItem>;
  screenSize: ScreenSize;
}

const components: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.description}>{children}</p>,
};

const Card = ({ data, screenSize }: Props) => {
  const [isOpenDescr, setIsOpenDescr] = useState(false);

  const cardRef = useOutsideClick(() => {
    if (screenSize.width >= screenSizes.desktop) return;

    if (isOpenDescr) setIsOpenDescr((prev) => !prev);
  });

  const handleToggleDescription = () => {
    if (screenSize.width >= screenSizes.desktop) return;

    setIsOpenDescr((prev) => !prev);
  };

  return (
    <li ref={cardRef as RefObject<HTMLLIElement>} className={styles.card}>
      <div className={`${styles.cardTop} ${styles.cardTopShown}`}>
        <p className={styles.title}>{data.title}</p>
        <button
          onClick={handleToggleDescription}
          className={styles.button}
          type="button"
          aria-label="Show back of the card"
        >
          <IconPlus />
        </button>
      </div>
      <p className={styles.cardValue}>{data.value}</p>
      <div
        className={`${styles.hiddenInfo} ${isOpenDescr ? styles.hiddenInfoActive : ''}`}
      >
        <div className={`${styles.cardTop} ${styles.cardTopHidden}`}>
          <p className={`${styles.title} ${styles.hiddenTitle}`}>
            {data.title}
          </p>
          <button
            onClick={handleToggleDescription}
            className={styles.button}
            type="button"
            aria-label="Close back of the card"
          >
            <IconMinus />
          </button>
        </div>
        <div className={styles.descriptionWrapper}>
          <PrismicRichText components={components} field={data.description} />
          <PrismicNextLink
            className={styles.link}
            field={data.description_link}
          >
            <LinkIcon className={styles.linkIcon} />
            Read the article
          </PrismicNextLink>
        </div>
      </div>
    </li>
  );
};

export default Card;
